import { styled } from '@mui/material';

import { Button } from '~/components/ui/button';
import { Icon } from '~/components/ui/icon';
import { DESKTOP_MIN_WIDTH, TABLET_MIN_WIDTH } from '~/constants/common';
import { COLORS } from '~/styles/colors';

// Custom props interfaces
interface StyledOptionIconWrapperProps {
  $isSelected: boolean;
}

// Styled components
export const StyledContainer = styled('section')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  paddingBottom: 75,
  [theme.breakpoints.down(DESKTOP_MIN_WIDTH)]: {
    backgroundColor: COLORS.grey100,
    padding: '60px 16px',
  },
}));

export const StyledTitleWrapper = styled('div')(({ theme }) => ({
  textAlign: 'center',
  marginBottom: 73,
  display: 'flex',
  marginTop: 106,
  gap: 8,
  [theme.breakpoints.down(DESKTOP_MIN_WIDTH)]: {
    flexDirection: 'column',
    alignItems: 'center',
  },
}));

export const StyledSeparator = styled('div')(() => ({
  borderBottom: `1px solid ${COLORS.grey150}`,
  paddingTop: 8,
  marginBottom: 17,
}));

export const StyledMainContentWrapper = styled('div')(({ theme }) => ({
  padding: '16px',
  backgroundColor: COLORS.grey100,
  borderRadius: '24px',
  display: 'flex',
  gap: '16px',
  [theme.breakpoints.down(DESKTOP_MIN_WIDTH)]: {
    padding: 0,
    marginTop: '16px',
  },
  [theme.breakpoints.down(TABLET_MIN_WIDTH)]: {
    flexDirection: 'column',
  },
}));

export const StyledPhonePreview = styled('div')(({ theme }) => ({
  padding: '58px 30px',
  borderRadius: '20px',
  backgroundColor: COLORS.white,
  display: 'flex',
  flex: 1,
  justifyContent: 'center',
  alignItems: 'center',
  minWidth: 350,
  maxWidth: '383px',
  img: {
    width: '100%',
    height: 'auto',
  },
  [theme.breakpoints.down(TABLET_MIN_WIDTH)]: {
    backgroundColor: COLORS.grey100,
    maxWidth: '72%',
    margin: '0 auto',
  },
}));

export const StyledOptionsWrapper = styled('div')(() => ({
  display: 'flex',
  gap: 20,
  overflow: 'auto',
  paddingTop: 7,
  paddingInline: 7,
  margin: '0 -7px',
  flexWrap: 'wrap',
}));

export const StyledOptionCard = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
  alignItems: 'center',
}));

export const StyledOptionIconWrapper = styled('button')<StyledOptionIconWrapperProps>(({ $isSelected }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '10px',
  height: '70px',
  width: '70px',
  boxSizing: 'border-box',
  backgroundColor: $isSelected ? COLORS.blue50 : '#FAFAFA',
  border: `1px solid ${$isSelected ? COLORS.blue100 : '#FAFAFA'}`,
  borderRadius: '12px',
  cursor: 'pointer',
  transition: 'background 0.2s ease, scale 0.3s ease',
  outline: 'none',
  '&:hover': {
    backgroundColor: COLORS.blue50,
    scale: '1.1',
  },
}));

export const StyledFeatureList = styled('div')(() => ({
  padding: '0',
  marginTop: '45px',
  marginBottom: '24px',
}));

export const StyledFeatureItem = styled('div')(() => ({
  marginBottom: '16px',
  display: 'flex',
  gap: '8px',
  '&:last-child': {
    marginBottom: 0,
  },
}));

export const StyledRightBlockItem = styled('div')(({ theme }) => ({
  backgroundColor: COLORS.white,
  padding: '26px 30px',
  borderRadius: '20px',
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  [theme.breakpoints.down(DESKTOP_MIN_WIDTH)]: {
    width: '100%',
  },

  '.poss-title': {
    marginLeft: '9px',
  },
}));

export const StyledRightBlock = styled('div')(() => ({
  display: 'flex',
  gap: '16px',
  flexDirection: 'column',
  flex: 2,
  maxWidth: '100%',
  overflow: 'auto',
}));

export const StyledCreateButton = styled(Button)(({ theme }) => ({
  width: 'fit-content',
  marginTop: 'auto',
  [theme.breakpoints.down(DESKTOP_MIN_WIDTH)]: {
    width: '100%',
  },
}));

export const StyledCheckIcon = styled(Icon)(() => ({
  path: {
    stroke: '#2196F3',
  },
}));
